import BotOpsHealthPanel from "./botOpsHealthPanel";

const KillToggleCard = ({
    title,
    descriptionOn,
    descriptionOff,
    enabled,
    loading,
    onToggle,
    ariaLabel,
    locked = false,
    lockedNote = "",
}) => (
    <section
        className={`rounded-lg border p-4 transition-colors ${
            enabled ? "border-green-600/50 bg-green-950/20" : "border-red-500/50 bg-red-950/20"
        }`}
    >
        <div className="flex flex-wrap items-center justify-between gap-4">
            <div>
                <p className="font-medium text-white">{title}</p>
                <p className="text-sm text-gray-400 mt-0.5">
                    {locked ? lockedNote : enabled ? descriptionOn : descriptionOff}
                </p>
            </div>
            <label
                className={`flex items-center gap-2 shrink-0 px-3 py-1.5 rounded-md border text-sm font-medium ${
                    locked
                        ? "border-gray-600/60 bg-gray-800/40 text-gray-400 cursor-not-allowed"
                        : enabled
                          ? "border-green-600/60 bg-green-900/30 text-green-300 cursor-pointer"
                          : "border-red-500/60 bg-red-900/30 text-red-300 cursor-pointer"
                }`}
            >
                <input
                    type="checkbox"
                    aria-label={ariaLabel}
                    checked={enabled}
                    disabled={loading || locked}
                    onChange={onToggle}
                    className="h-4 w-4 accent-[#d59106]"
                />
                <span>{locked ? "Travado" : enabled ? "Ativo" : "Desligado"}</span>
            </label>
        </div>
    </section>
);

const BotOpsOperarPanel = ({
    enabled,
    sandboxEnabled,
    killLoading,
    sandboxKillLoading,
    inboxKills = [],
    inboxKillLoading = null,
    onKillToggle,
    onSandboxKillToggle,
    onInboxKillToggle,
    token,
    onAfterMutation,
    activeVersion,
}) => {
    return (
        <div className="flex flex-col gap-4 mb-6">
            <KillToggleCard
                title="Produção — chave geral"
                descriptionOn="Bot liberado nas inboxes habilitadas abaixo"
                descriptionOff="Kill geral ativo — nenhuma inbox com bot; conversas na fila Triagem"
                enabled={enabled}
                loading={killLoading}
                onToggle={onKillToggle}
                ariaLabel="Kill geral de produção"
            />

            {inboxKills.length > 0 && (
                <div className="flex flex-col gap-2 pl-4 border-l-2 border-gray-700/60">
                    {inboxKills.map((inbox) => (
                        <KillToggleCard
                            key={inbox.inbox_id}
                            title={`WhatsApp ${inbox.origem || `inbox ${inbox.inbox_id}`} · inbox #${inbox.inbox_id}`}
                            descriptionOn="Bot respondendo clientes nesta inbox (exige a chave geral ligada)"
                            descriptionOff="Sem turno IA nesta inbox — conversas caem na fila humana"
                            enabled={inbox.enabled === true}
                            loading={inboxKillLoading === inbox.inbox_id}
                            onToggle={() => onInboxKillToggle?.(inbox.inbox_id)}
                            ariaLabel={`Bot na inbox ${inbox.origem || inbox.inbox_id}`}
                            locked={inbox.protected === true}
                            lockedNote="Produção real — o bot não liga nesta inbox (proteção BOT_PROTECTED_INBOX_IDS, só muda via deploy)"
                        />
                    ))}
                </div>
            )}

            <KillToggleCard
                title="Sandbox (chat e testes)"
                descriptionOn="Chat e testes com turno IA"
                descriptionOff="Sandbox desligado — chat de teste sem turno IA (sem Triagem)"
                enabled={sandboxEnabled}
                loading={sandboxKillLoading}
                onToggle={onSandboxKillToggle}
                ariaLabel="Kill do sandbox"
            />

            <BotOpsHealthPanel
                token={token}
                onAfterMutation={onAfterMutation}
                activeVersion={activeVersion}
            />
        </div>
    );
};

export default BotOpsOperarPanel;
